<template>
   <div class="container py-5">
      <h1 class="display-6 text-center">Our Blog 123</h1>
       <!-- Intro Section -->
        <div class="lead text-center mb-5">
            Coming soon...
        </div>
       </div>
</template>